import { IconProps } from "@models/types";

export function FIlterIcon(props: IconProps) {
  return (
    <>
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        {...props}
      >
        <g id="_" className="isolate">
          <g className="isolate">
            <path
              className="fill-none stroke-black stroke-[1.4px]"
              d="m1.59,3.29c.22-.47.69-.76,1.21-.76h14.41c.52,0,.98.3,1.2.76.22.47.15,1.02-.2,1.42l-6.07,7.46v4.24c0,.4-.23.77-.59.95-.36.18-.79.14-1.12-.1l-2.13-1.6c-.27-.2-.43-.52-.43-.85v-2.64L1.76,4.71c-.33-.4-.39-.95-.17-1.42Z"
            />
          </g>
        </g>
      </svg>
    </>
  );
}
